import type { AreaCatalog } from '../area';
import type { flows as en } from '../en/flows';

export const flows = {
  // --- The Flows index ---
  'flows.index.title': 'Abläufe',
  'flows.index.sub': 'wie Aufgaben vorankommen',
  'flows.index.count': { one: '{count} Ablauf', other: '{count} Abläufe' },
  'flows.index.empty':
    'Noch keine Abläufe. Ein Ablauf beschreibt, wie Aufgaben vorankommen: Phasen in fester Reihenfolge, Entscheidungen an den Schwellen, eigene Felder. Er erreicht, wen sein Zugriff nennt, und Boards nutzen ihn für ihre Spalten. Erstelle einen und verknüpfe ihn über „Einrichten“ eines Boards.',
  'flows.index.archived': 'Archiviert',
  'flows.sort.name': 'Name (A–Z)',
  'flows.sort.phases': 'Meiste Phasen',
  'flows.sort.menu': 'Sortieren nach',
  'flows.sort.label': 'Abläufe sortieren',
  'flows.card.phases': { one: '{count} Phase', other: '{count} Phasen' },
  'flows.card.fields': { one: '{count} Feld', other: '{count} Felder' },
  // --- New flow ---
  'flows.new.open': 'Neuer Ablauf',
  'flows.new.title': 'Neuer Ablauf',
  'flows.new.cancel': 'Abbrechen',
  'flows.new.create': 'Erstellen',
  'flows.new.name': 'Name',
  'flows.new.nameHint':
    'Freie Wortwahl; jederzeit umbenennbar (der feste Schlüssel wird einmal vergeben).',
  'flows.new.namePlaceholder': 'z. B. Auslieferung, Recruiting, Produktentwicklung',
  'flows.new.nameLabel': 'Name des Ablaufs',
  'flows.new.owner': 'Verwaltet von',
  'flows.new.ownerHint':
    'Die Gruppe oder Person, die diesen Ablauf besitzt und verwaltet; ihre eigenen Boards können ihn für ihre Spalten verknüpfen.',
  'flows.new.ownerLabel': 'Wer den Ablauf verwaltet',
  // --- What a new flow is born with ---
  'flows.starter.stage.toDo': 'Zu erledigen',
  'flows.starter.stage.inProgress': 'In Arbeit',
  'flows.starter.stage.done': 'Fertig',
  'flows.starter.name.personal': 'Mein Ablauf',
  'flows.starter.name.group': 'Ablauf {group}',
  'flows.starter.name.fallback': 'Neuer Ablauf',
  // --- A flow's page: the head ---
  'flows.detail.kind': 'Ablauf',
  'flows.detail.owners': 'verwaltet von {owners}',
  'flows.detail.archived': 'archiviert',
  // --- Access ---
  'flows.access.bubbles': 'Zugriff auf {flow}',
  'flows.access.title': 'Zugriff',
  'flows.access.loading': 'Wird geladen…',
  'flows.access.unreachable': 'Dieser Ablauf ist nicht erreichbar.',
  'flows.access.footnote':
    'Der Personenkreis sieht diesen Ablauf und die Aufgaben, die mit ihm geteilt sind. Änderungen am Zugriff stehen im Verlauf des Ablaufs.',
  // --- The save bar, the actions menu and archive ---
  'flows.config.name': 'Name',
  'flows.config.nameHint': 'Umbenennen macht nichts kaputt.',
  'flows.config.nameLabel': 'Name des Ablaufs',
  'flows.config.fixFirst': 'Behebe vor dem Speichern die markierten Probleme.',
  'flows.config.discardAsk': 'Alle ungespeicherten Änderungen verwerfen?',
  'flows.config.discard': 'Verwerfen',
  'flows.config.keepEditing': 'Zurück zum Bearbeiten',
  'flows.config.discardChanges': 'Änderungen verwerfen',
  'flows.config.save': 'Änderungen speichern',
  'flows.config.actionsFor': 'Aktionen für {flow}',
  'flows.config.actions': 'Aktionen des Ablaufs',
  'flows.config.unarchive': 'Archivierung aufheben',
  'flows.config.archive': 'Archivieren…',
  'flows.archive.title': 'Diesen Ablauf archivieren?',
  'flows.archive.keep': 'Behalten',
  'flows.archive.confirm': 'Ablauf archivieren',
  'flows.archive.body':
    'Der Verlauf bleibt, und verknüpfte Boards zeigen wieder Statusspalten; Aufgaben bewegen sich nicht mehr durch ihn. Du kannst die Archivierung später in diesem Menü aufheben.',
  'flows.archive.note':
    'Archiviert: Der Verlauf bleibt, nichts Neues bewegt sich durch ihn; verknüpfte Boards zeigen wieder Statusspalten.',
  // --- Findings ---
  'flows.findings.label': 'Befunde des Ablaufs',
  'flows.findings.word.noUndo': 'Regel abgewiesen: Rücknahme',
  'flows.findings.word.noRevisit': 'Regel abgewiesen: Hin und Her',
  'flows.findings.word.hopBudget': 'Kette gestoppt',
  'flows.findings.word.potentialCycle': 'Möglicher Kreislauf',
  'flows.findings.word.dispatch': 'Aktion abgewiesen',
  'flows.findings.hint.noUndo':
    'Eine Regel wollte genau die Aktion rückgängig machen, die sie ausgelöst hat, daher wurde ihre Aktion abgewiesen. Eine Regel, die ihren eigenen Auslöser rückgängig macht, ist meist eine als Aktion geschriebene Voraussetzung: Verschiebe die Bedingung nach „Karte darf hierher, wenn“.',
  'flows.findings.hint.noRevisit':
    'Eine Regel wollte einen Wert setzen, den diese Kette von Automatisierungen schon einmal gesetzt hatte, daher wurde ihre Aktion abgewiesen: Das ist Hin und Her, kein Fortschritt.',
  'flows.findings.hint.hopBudget':
    'Eine Aktion hat mehr automatische Schritte ausgelöst, als das Budget erlaubt (8), daher wurde die Kette hier gestoppt.',
  'flows.findings.hint.potentialCycle':
    'Mit einer Warnung gespeichert: Unter manchen Bedingungen können diese Regeln in sich selbst zurücklaufen. Abgewiesen wurde noch nichts.',
  'flows.findings.hint.dispatch':
    'Die Aktion einer Regel wurde beim Ausführen abgewiesen: Sie war für die Aufgabe nicht mehr zulässig, oder dem Ablauf fehlte das Recht.',
  'flows.findings.hint.unknown': 'Die Regeln des Ablaufs haben das beim Ausführen gemeldet.',
  'flows.findings.version': 'v{version}',
  'flows.findings.about': 'Zu diesem Befund',
  'flows.findings.rule': 'Regel: {key}',
  // --- The stage editor: the stage list ---
  'flows.stages.title': 'Phasen',
  'flows.stage.untitled': 'Unbenannte Phase',
  'flows.stage.about': 'Zu dieser Phase',
  'flows.stage.moveUp': 'Phase {stage} nach oben',
  'flows.stage.moveDown': 'Phase {stage} nach unten',
  'flows.stage.expand': 'Phase {stage} aufklappen',
  'flows.stage.edit': 'Phase {stage} bearbeiten',
  'flows.stage.collapse': 'Phase einklappen',
  'flows.stage.add': '+ Phase hinzufügen',
  'flows.stage.means': 'bedeutet',
  'flows.stage.onLeaving.keep': '(beim Verlassen: behalten)',
  'flows.stage.onLeaving.clear': '(beim Verlassen: aufheben)',
  'flows.stage.help.applies':
    'Verschieben hierher setzt die aufgeführten Werte in einem Schritt; lässt sich ein Wert nicht setzen, wird das ganze Verschieben abgewiesen. Macht eine Aktion ALLE aufgeführten Werte wahr, wandert die Karte von selbst hierher, im Protokoll vermerkt.',
  'flows.stage.help.requirements':
    'Ein Verschieben, das die aufgeführten Voraussetzungen nicht erfüllt, wird abgewiesen, und der Grund wird genannt.',
  'flows.stage.help.whoRequester': 'Nur Verantwortliche dürfen Karten hierher verschieben.',
  'flows.stage.help.whoContributor': 'Nur Zuständige dürfen Karten hierher verschieben.',
  'flows.stage.help.whoOwner': 'Nur wer den Ablauf verwaltet, darf Karten hierher verschieben.',
  'flows.stage.help.manual':
    'Eine Spalte nur zum Sortieren von Hand: Verschieben hierher ändert nichts an der Aufgabe, und nichts verschiebt Karten von selbst hierher.',
  'flows.stage.problem.label': 'Eine Phase braucht eine Bezeichnung.',
  'flows.stage.problem.applies': 'Eine Bedeutung nennt jedes Merkmal nur einmal.',
  // --- The stage editor: the open panel ---
  'flows.stage.label': 'Bezeichnung',
  'flows.stage.labelAbout': 'Zur Bezeichnung',
  'flows.stage.labelHelp':
    'Erscheint auf Karten, in Board-Spalten und auf der Seite der Aufgabe. Jederzeit änderbar.',
  'flows.stage.labelField': 'Bezeichnung der Phase',
  'flows.stage.description': 'Beschreibung',
  'flows.stage.descriptionAbout': 'Zur Beschreibung',
  'flows.stage.descriptionHelp':
    'Optional. Eine Notiz in deinen eigenen Worten, wofür diese Phase da ist; sie erscheint, wenn jemand mit der Maus auf die Board-Spalte zeigt. Sie steht neben den Werten, die die Phase setzt, und ersetzt sie nie.',
  'flows.stage.descriptionField': 'Beschreibung der Phase',
  'flows.stage.descriptionPlaceholder': 'Wofür diese Phase da ist (optional)',
  'flows.stage.who': 'Wer Karten hierher verschieben darf',
  'flows.stage.whoAbout': 'Zur Frage, wer Karten hierher verschieben darf',
  'flows.stage.whoHelp':
    'Ohne Auswahl dürfen Mitglieder Karten verschieben, und ein Verschieben durch nicht Zuständige wird im Protokoll markiert, nie verhindert. Mit einer Auswahl wird es stattdessen abgewiesen.',
  'flows.stage.who.members': 'Mitglieder',
  'flows.stage.who.requesters': 'Verantwortliche',
  'flows.stage.who.contributors': 'Zuständige',
  'flows.stage.who.owners': 'Wer den Ablauf verwaltet',
  'flows.stage.requirements': 'Karte darf hierher, wenn',
  'flows.stage.requirementsAbout': 'Zu den Voraussetzungen',
  'flows.stage.requirementsHelp':
    'Ein Verschieben, das eine Voraussetzung nicht erfüllt, wird abgewiesen, und die Ablehnung nennt die Voraussetzung.',
  'flows.stage.attribute': 'Merkmal',
  'flows.stage.mustBe': 'Muss sein',
  'flows.stage.value': 'Wert',
  'flows.stage.removeRequirement': 'Voraussetzung entfernen',
  'flows.stage.addRequirement': '+ Voraussetzung hinzufügen',
  'flows.stage.applies': 'Verschieben hierher setzt',
  'flows.stage.appliesAbout': 'Zu den gesetzten Werten',
  'flows.stage.appliesHelp':
    'Was es BEDEUTET, hier zu stehen: Das Verschieben setzt diese Werte in einem Schritt (lässt sich einer nicht setzen, wird das ganze Verschieben abgewiesen), und eine Karte, deren Werte gerade genau diese geworden sind, wandert von selbst hierher, im Protokoll vermerkt. „Beim Verlassen“ gibt es, wo sich der Wert aufheben lässt: Zustände und Felder bieten behalten oder aufheben. Handlungen wie das Setzen auf Fertig machen das Verlassen einer Spalte nicht rückgängig.',
  'flows.stage.onLeavingInline': 'beim Verlassen',
  'flows.stage.onLeaving': 'Beim Verlassen',
  'flows.stage.removeApplied': 'Gesetzten Wert entfernen',
  'flows.stage.addPair': '+ Paar hinzufügen',
  'flows.stage.attr.delivered': 'Fertigstellung',
  'flows.stage.attr.closed': 'Abschluss',
  'flows.stage.attr.active': 'Aktiv',
  'flows.stage.attr.verdict': 'Bewertung',
  'flows.stage.attr.cancelled': 'Abgebrochen',
  'flows.stage.attr.health': 'Zustand',
  'flows.stage.val.yes': 'ja',
  'flows.stage.val.no': 'nein',
  'flows.stage.val.worn': 'gesetzt',
  'flows.stage.val.clear': 'aufgehoben',
  'flows.stage.val.noVerdict': 'noch keine',
  'flows.stage.val.accepted': 'Abgenommen',
  'flows.stage.val.denied': 'Abnahme verweigert',
  'flows.stage.val.keep': 'behalten',
  'flows.stage.val.clearOnLeaving': 'aufheben',
  'flows.stage.val.any': 'beliebiger Wert',
  'flows.stage.val.placeholder': 'Wert',
  'flows.stage.pickState': 'Zustand wählen',
  'flows.policy.title': 'Wenn eine Automatisierung fragt',
  'flows.policy.about': 'Zu den Antworten der Automatisierungen',
  'flows.policy.help':
    'Eine Automatisierung wartet nie auf eine Person. Wirft ihre Aktion eine Frage auf (beim Abschließen noch offene Unteraufgaben oder eine Aktion, für die sie nicht zuständig ist), tut sie, was hier als Antwort steht. „Verantwortliche fragen“ legt die Frage einmal den Verantwortlichen der Aufgabe vor, egal wie oft sie auslöst; „Mit Befund überspringen“ tut nichts und meldet es dir an diesem Ablauf.',
  'flows.policy.automation': 'Automatisierung',
  'flows.policy.question': 'Frage',
  'flows.policy.answer': 'Antwort',
  'flows.policy.onEntering': 'Beim Betreten: {command}',
  'flows.policy.onLeaving': 'Beim Verlassen: {command}',
  'flows.policy.answerFor': 'Antwort auf „{question}“ für {command}',
  'flows.policy.class.openChildren': 'Unteraufgaben noch offen',
  'flows.policy.class.outOfRole': 'Nicht zuständig',
  'flows.policy.class.cascadeSize': 'Zu groß',
  'flows.policy.leaveOpen': 'Offen lassen',
  'flows.policy.closeSafe': 'Den sicheren Teil abschließen',
  'flows.policy.closeAll': 'Alle abschließen',
  'flows.policy.askRequester': 'Verantwortliche fragen',
  'flows.policy.skip': 'Mit Befund überspringen',
  'flows.policy.goAhead': 'Ja, trotzdem handeln',
  'flows.stage.removeAsk':
    'Diese Phase entfernen? Karten behalten ihren Verlauf; die Spalte verschwindet aus den Boards.',
  'flows.stage.remove': 'Phase entfernen',
  'flows.stage.keep': 'Behalten',
  // --- The save refusal ---
  'flows.refusal.overlap': 'Speichern nicht möglich: Zwei Phasen können denselben Status bedeuten',
  'flows.refusal.overlapHelp':
    'Zwei Phasen, deren Bedeutungen gleichzeitig zutreffen können, lassen der Maschine zwei Ziele. Fasse die Paare einer Phase enger.',
  'flows.refusal.jointly': 'beide treffen zu bei · {jointly}',
  'flows.refusal.cycle':
    'Speichern nicht möglich: Diese Automatisierungen laufen in sich selbst zurück',
  'flows.refusal.cycleHelp':
    'Die Automatisierungen dieser Phasen würden unabhängig vom Zustand in sich selbst zurücklaufen, daher wird das Speichern abgewiesen. Verknüpfe eine Seite neu: Ein „darf nicht“ gehört nach „Karte darf hierher, wenn“, nie in eine Aktion, die die Karte zurückwirft.',
  'flows.refusal.plain': 'Speichern nicht möglich',
  'flows.refusal.about': 'Zu dieser Ablehnung',
  'flows.refusal.step': '{stage} · {edge}',
  'flows.refusal.edge.enter': 'Betreten',
  'flows.refusal.edge.leave': 'Verlassen',
  'flows.refusal.edge.pull': 'Nachziehen',
  // --- Fields ---
  'flows.fields.title': 'Felder dieses Ablaufs',
  'flows.fields.requiredToEnter': 'Voraussetzung für {stage}',
  'flows.fields.appliedBy': 'gesetzt von {stage}',
  // --- Health rules ---
  'flows.rules.title': 'Zustandsregeln',
  'flows.rules.help':
    'Wie dieser Ablauf einen Fakt nennt, sobald er eine Zahl überschreitet, die du wählst. {callIt} setzt das Wort auf jede Aufgabe im Ablauf, für die er gilt: Die Aufgabe trägt es, alle, die die Aufgabe sehen, sehen es, und es verschwindet mit dem Fakt. {suggest} fragt stattdessen die Leute dieses Ablaufs: Keine Farbe ändert sich, bis jemand annimmt, und gefragt wird nur, wer diesen Ablauf sieht. Eine Aufgabe in keinem Ablauf behält den Fakt und kein Wort.',
  'flows.rules.callIt': 'Nennen',
  'flows.rules.suggest': 'Vorschlagen',
  'flows.evidence.holding': 'Gilt gerade: {list}',
  'flows.evidence.firing': '{items} × {word} ({grade})',
  'flows.evidence.grade.notice': 'Hinweis',
  'flows.evidence.grade.warning': 'Warnung',
  'flows.evidence.grade.critical': 'kritisch',
  'flows.evidence.criticals':
    'In den letzten 30 Tagen von diesen Regeln kritisch gesetzt: {count}. Eine kritische Stufe unterbricht alle Beteiligten.',
  'flows.evidence.ungraded': {
    one: 'Hier noch unbenannt, bei {count} Aufgabe im Ablauf: {list}. Eine Regel wert?',
    other: 'Hier noch unbenannt, bei {count} Aufgaben im Ablauf: {list}. Eine Regel wert?',
  },
  'flows.evidence.ungradedEntry': '{fact} bei {items}',
  'flows.channel.info': 'nur in der Übersicht: ein reiner Fakt, keine Farbe',
  'flows.channel.notice':
    'nur in der Übersicht: sichtbar, wo du ohnehin hinschaust, benachrichtigt nie Beteiligte',
  'flows.channel.warning':
    'färbt den Punkt und zählt auf den weitergeleiteten Flächen mit; benachrichtigt nie Beteiligte',
  'flows.channel.critical':
    'benachrichtigt: sendet an Beteiligte und Abonnierende, also sparsam einsetzen',
  'flows.unmet.condition': 'Schwelle nach „{stage}“: Bedingung {condition} ist nicht abgenommen.',
  'flows.unmet.requiredFields': '„{stage}“ verlangt ausgefüllte Felder: {fields}.',
  'flows.unmet.gate': 'Die Schwelle zu „{stage}“ ist nicht erfüllt.',
  'flows.unmet.joined': '{first} · {second}',
} as const satisfies AreaCatalog<typeof en>;
